import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ICorrelation } from '@app/api/interfaces/correlation.interface';
import { getCommonStateStatusCssColor } from '@app/main/leak-detection/utils/common-state-status-css-color';
import { ProgressBar } from 'primeng/progressbar';
import { LdCorrelationTypeIconComponent } from '@app/main/leak-detection/components/ld-helper/ld-correlation-type-icon/ld-correlation-type-icon.component';
import { TranslateDirective } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'gc-ld-correlation-type-icon-with-quality',
  imports: [NgClass, LdCorrelationTypeIconComponent, ProgressBar, TranslateDirective],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-correlation-type-icon-with-quality.component.html',
  styleUrl: './ld-correlation-type-icon-with-quality.component.scss',
})
export class LdCorrelationTypeIconWithQualityComponent {
  public correlation = input.required<ICorrelation>();
  public primaryColor = input<boolean>(false);
  public small = input<boolean>(false);

  public qualityColor = computed(() => {
    const correlation = this.correlation();

    return correlation ? getCommonStateStatusCssColor(correlation.qualityStatus) : 'transparent';
  });
}
